import { DefaultRestService, defineAPIs } from '@sydle/ui-api';
import { OneApi } from '../components/one-api/one-api';
import { EnvEndpoints } from '../store/env/env.endpoints';
import { initStore } from '../store/store';
import { UserEndpoints } from '../store/user/user.endpoints';

import { WORKSPACE_MESSAGES_BUNDLE_ID } from '../api/constants';
import { TranslationBundles } from '../components/one-translation-bundle/translation-bundles';
import { OrganizationEndpoints } from '../store/organization/organization.endpoints';
import { getDisableFieldLocalizedFeedbacks } from './one-components-config';

export default async (): Promise<void> => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */
  // Initializing ONE API

  defineAPIs();

  OneApi.init(new DefaultRestService(), true, getDisableFieldLocalizedFeedbacks());
  initStore();
  loadTranslationBundle();
  await Promise.all([loadEnvToStore()]);
};

async function loadTranslationBundle() {
  await TranslationBundles.load({
    bundleIdentifier: 'WORKSPACE_MESSAGES',
    bundleId: WORKSPACE_MESSAGES_BUNDLE_ID,
    language: OneApi.userAPI.getCurrentLanguage(),
    public: true,
  });
}

async function loadEnvToStore() {
  // Loading logged user
  UserEndpoints.loadLoggedUser.fetch();

  // Loading current language
  EnvEndpoints.loadCurrentLanguage.fetch();

  // Loading organization configs
  await OrganizationEndpoints.getConfigs.fetch(null, { forceRefetch: false });
}
